import { InputHTMLAttributes, forwardRef } from 'react';
import { clsx } from 'clsx';

interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  error?: string;
}

export const Input = forwardRef<HTMLInputElement, InputProps>(
  ({ label, error, className, ...props }, ref) => {
    return (
      <div className="w-full">
        {label && (
          <label className="block text-sm font-medium text-white/80 mb-2">
            {label}
          </label>
        )}
        <input
          ref={ref}
          className={clsx('glass-input', error && 'border-error-500', className)}
          {...props}
        />
        {error && (
          <p className="mt-1 text-sm text-error-400">{error}</p>
        )}
      </div>
    );
  }
);

Input.displayName = 'Input';
